import { msg } from "@lingui/core/macro";
import { useLingui } from "@lingui/react";

import { FindingView } from "../../findings/FindingView";
import type { Finding } from "../../model/Finding";

const TITLE = msg({ id: "analysis.more_fixes.title", message: "Also fix" });

type MoreFixesProps = {
  // Следующие по важности ошибки после главной (`selectFixFirst`), не больше двух.
  findings: readonly Finding[];
};

// «Ещё исправить»: строка на ошибку — что случилось и общий совет. Нечего — блока нет.
export const MoreFixes = ({ findings }: MoreFixesProps) => {
  const { _ } = useLingui();
  if (findings.length === 0) {
    return null;
  }
  return (
    <section
      aria-labelledby="analysis-more-fixes"
      className="flex flex-col gap-3.5 rounded-xl border border-border bg-surface px-4.5 py-4"
    >
      <h2 id="analysis-more-fixes" className="text-base font-semibold text-warn">
        {_(TITLE)}
      </h2>
      <ul className="flex flex-col divide-y divide-border">
        {findings.map((finding, index) => (
          // Порядок и состав находок разбора не меняются — индекс как ключ безопасен.
          <li key={index} className="py-3 first:pt-0 last:pb-0">
            <FindingView finding={finding} variant="row" />
          </li>
        ))}
      </ul>
    </section>
  );
};
